import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
    const { t } = useTranslation();

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-section">
                    <div className="footer-logo">
                        <img src={require('../../assets/images/acs-logo.png')} alt="ACS Logo" className="logo-img" />
                    </div>
                    <p className="footer-description">{t('footer.description')}</p>
                </div>

                <div className="footer-section">
                    <h4>{t('footer.links')}</h4>
                    <nav className="footer-links">
                        <Link to="/">{t('nav.home')}</Link>
                        <Link to="/products">{t('nav.products')}</Link>
                        <Link to="/about">{t('nav.about')}</Link>
                        <Link to="/contact">{t('nav.contact')}</Link>
                    </nav>
                </div>

                <div className="footer-section">
                    <h4>{t('footer.contact')}</h4>
                    <div className="footer-contact">
                        <p>📞 {t('contact.info.phone')}</p>
                        <p>📱 {t('contact.info.mobile')}</p>
                        <p>📧 acs-dispatch@ala-catering.kz</p>
                        <p>📧 sales@ala-catering.kz</p>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; 2026 Fly Catering. {t('footer.rights')}</p>
            </div>
        </footer>
    );
};

export default Footer;
